<template>
  <div class="route-transports">
    <a-spin v-if="loading" class="route-transports__spin" />

    <a-empty
      v-else-if="!items.length"
      class="route-transports__empty"
      description="Nenhum meio de transporte encontrado."
    />

    <template v-else>
      <div
        v-for="transport in visibleItems"
        :key="transport.id"
        class="route-transports__row"
      >
        <FreightTableTruckIcon class="route-transports__row-icon" />

        <span class="route-transports__info">
          <span class="route-transports__label">Tipo rodado:</span>
          {{ transport.rodado }}
          <span class="route-transports__separator">•</span>
          <span class="route-transports__label">Carroceria:</span>
          {{ transport.carroceria }}
          <span class="route-transports__separator">•</span>
          <span class="route-transports__label">Carga perigosa:</span>
          {{ transport.cargaPerigosa }}
          <span class="route-transports__separator">•</span>
          <span class="route-transports__label">Refrigerado:</span>
          {{ transport.refrigerado }}
          <template v-if="transport.temValorSaida">
            <span class="route-transports__separator">•</span>
            <span class="route-transports__label">Valor de saída:</span>
            {{ transport.valorSaida }}
          </template>
        </span>

        <div class="route-transports__row-actions">
          <StatusBadge :label="transport.status" :active="isActive(transport)" />
        </div>
      </div>

      <a
        v-if="hasMore"
        class="route-transports__show-all"
        href="#"
        @click.prevent="showAll = !showAll"
      >
        {{ showAll ? "Exibir menos" : "Exibir todos" }}
        <a-icon :type="showAll ? 'up' : 'down'" />
      </a>
    </template>
  </div>
</template>

<script>
import StatusBadge from "@/shared/components/StatusBadge.vue";
import FreightTableTruckIcon from "../FreightTableTruckIcon.vue";
import { FREIGHT_TABLE_STATUS } from "../../constants/freightTableStatus";

const COLLAPSED_LIMIT = 4;

export default {
  name: "FreightTableRouteTransports",
  components: { StatusBadge, FreightTableTruckIcon },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    visibleItems() {
      return this.showAll ? this.items : this.items.slice(0, COLLAPSED_LIMIT);
    },
    hasMore() {
      return this.items.length > COLLAPSED_LIMIT;
    },
  },
  methods: {
    isActive(transport) {
      return transport.statusValor === FREIGHT_TABLE_STATUS.ATIVA;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.route-transports {
  &__spin,
  &__empty {
    display: block;
    padding: 24px;
    text-align: center;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid @color-bg-subtle;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 8px;
  }

  &__row-icon {
    color: @color-primary;
    flex-shrink: 0;
  }

  &__info {
    font-size: 14px;
    color: @color-text-dark;
    min-width: 0;
  }

  &__label {
    color: @color-text-light;
  }

  &__separator {
    color: @color-text-muted;
    margin: 0 6px;
  }

  &__row-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    padding-left: 8px;
    flex-shrink: 0;
  }

  &__show-all {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: @color-primary;
    font-weight: 500;
    margin-top: 8px;

    &:hover,
    &:focus {
      color: @color-primary-hover;
      text-decoration: none;
    }
  }
}
</style>
